module.exports = __webpack_public_path__ + "static/media/01.f3ea75a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/volumetric/supplements/01.png
// module id = 642
// module chunks = 0